import { useMemo } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import { usePremierDestinationPromotion } from "@hsbc/portal";
import { EarnBreakdownCard } from "./EarnBreakdownCard";
import { useCardEarnList } from "./hooks";
import styles from "./styles.module.scss";

export const PremierDestinationEarnDialog = () => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "PremierDestinationEarnDialog");

  const {
    promotions,
    activePremierDestinations: { hotels: activePremierDestinations },
  } = usePremierDestinationPromotion();

  const { hotelEarnList, flightEarnList } = useCardEarnList({ promotions });

  const countryList = useMemo(
    () => activePremierDestinations.map((c) => c.title),
    [activePremierDestinations]
  );

  return (
    <div className={block}>
      <div className={cn("description-container")}>
        <span className={cn("description")}>
          <Trans
            i18nKey="premierDestinations.earnDialog.description"
            components={[<span className={cn("bold")} />]}
          />
        </span>

        <span className={cn("terms")}>
          {t("premierDestinations.earnDialog.termsAndConditions")}
        </span>
      </div>

      <span className={cn("title")}>{t("premierDestinations.title")}</span>

      <div className={cn("destinations-container")}>
        <span className={cn("destinations-title")}>
          {t("premierDestinations.title")}
        </span>

        <ul className={cn("destinations")}>
          {countryList.map((country) => (
            <li key={country} className={cn("country-list-item")}>
              {country}
            </li>
          ))}
        </ul>
      </div>

      <span className={cn("title")}>
        {t("premierDestinations.earnDialog.earnBreakdownTitle")}
      </span>

      <EarnBreakdownCard earnList={hotelEarnList} title={t("hotels")} />

      <EarnBreakdownCard
        earnList={flightEarnList}
        title={t("premierDestinations.earnDialog.flightsAndCars")}
      />
    </div>
  );
};
